import React, { useState, useEffect } from "react"
import { Box, Dialog, DialogContent, Typography, IconButton } from "@mui/material"
import styled from "@emotion/styled"
import { useTheme } from "@mui/system"
import CloseIcon from "@mui/icons-material/Close"
import AppButton from "components/StyledComponents/AppButton"
import AppTextField from "components/StyledComponents/AppTextField"
import style from "../league.module.scss"

const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiPaper-root": {
    backgroundColor: "transparent",
    maxWidth: 600,
    width: "100%"
  },
  "& .MuiDialogContent-root": {
    backgroundColor: theme.palette.background.default,
    borderRadius: 12,
    border: "none",
    width: "100%",
    padding: 32,
    boxSizing: "border-box"
  }
}))

const RegeneratePodsModal = ({ open, onClose, onSave }) => {
  const theme = useTheme()
  const [numPods, setNumPods] = useState("")
  const [error, setError] = useState("")

  const styles = {
    closeBtn: {
      color: theme.palette.text.primary,
      position: "absolute",
      top: "10px",
      right: "10px",
      backgroundColor: theme.palette.background.main
    }
  }

  useEffect(() => {
    if (open) {
      setNumPods("")
      setError("")
    }
  }, [open])

  const handleSave = () => {
    const value = Number(numPods)
    if (!numPods || Number.isNaN(value) || !Number.isInteger(value) || value <= 0) {
      setError("Enter a number of pods greater than 0")
      return
    }
    onSave(value)
  }

  const handleChange = (e) => {
    setNumPods(e.target.value)
    if (error) setError("")
  }

  return (
    <StyledDialog open={open} onClose={onClose}>
      <DialogContent>
        <Box className="d-flex justify-content-end">
          <IconButton onClick={onClose} sx={styles.closeBtn}>
            <CloseIcon className={style.closeIcon} />
          </IconButton>
        </Box>

        <Box className="w-100 d-flex justify-content-center mb-2">
          <Typography variant="h2">Regenerate Pods</Typography>
        </Box>

        <Box flexDirection="column" className="mt-4">
          <Box className="w-100 py-2">
            <AppTextField
              id="numPods"
              name="numPods"
              isUpperCase={true}
              type="number"
              fullWidth
              label="Number of Pods"
              isRequired={true}
              placeholder="Enter number of pods"
              value={numPods}
              onChange={handleChange}
              error={Boolean(error)}
              helperText={error}
              inputProps={{ min: 1 }}
            />
          </Box>
        </Box>

        <Box className="mt-5 d-flex justify-content-center">
          <AppButton onClick={handleSave} className={style.regenerateButton}>
            Regenerate
          </AppButton>
        </Box>
      </DialogContent>
    </StyledDialog>
  )
}

export default RegeneratePodsModal
